import { createSlice } from "@reduxjs/toolkit";
import { RESET_AUTHENTICATION, SET_AUTHENTICATION } from 'services/redux/action-types'
import { authenticationConstants } from "services/redux/authentication/constants";

const initialState = {
	[authenticationConstants.LOGGED_IN]: null,
	[authenticationConstants.TOKEN_REVALIDATE]: null,
};

const authenticationSlice = createSlice({
	name: 'authentication',
	initialState,
	reducers: {},
	extraReducers: ( builder ) => {
		builder
			.addCase( SET_AUTHENTICATION, ( state, action ) => {
				// RESET_AUTHENTICATION historically uses false as a signed-out sentinel.
				return {
					...state,
					[ action.key ]: action.payload,
				};
			})
			.addCase( RESET_AUTHENTICATION, () => {
				return false;
			});
	},
});

export default authenticationSlice.reducer;
